import axios from "axios";
import qs from "qs";
import _, { get } from "lodash";
import * as fileActions from "./file";
import moment from "moment";

const ADMINTAGS_LIST_LOAD = "ADMINTAGS_LIST_LOAD";
const ADMINTAGS_LIST_SUCCESS = "ADMINTAGS_LIST_SUCCESS";
const ADMINTAGS_LIST_FAILED = "ADMINTAGS_LIST_FAILED";
const ADMINTAGS_SET_LOADING = "ADMINTAGS_SET_LOADING";

const ADMINTAGS_FORM_LOAD = "ADMINTAGS_FORM_LOAD";
const ADMINTAGS_FORM_SUCCESS = "ADMINTAGS_FORM_SUCCESS";
const ADMINTAGS_FORM_FAILED = "ADMINTAGS_FORM_FAILED";

const ADMINTAGS_DELETE_LOAD = "ADMINTAGS_DELETE_LOAD";
const ADMINTAGS_DELETE_SUCCESS = "ADMINTAGS_DELETE_SUCCESS";
const ADMINTAGS_DELETE_FAILED = "ADMINTAGS_DELETE_FAILED";

const ADMINTAGS_EDIT_LOAD = "ADMINTAGS_EDIT_LOAD";
const ADMINTAGS_EDIT_SUCCESS = "ADMINTAGS_EDIT_SUCCESS";
const ADMINTAGS_EDIT_FAILED = "ADMINTAGS_EDIT_FAILED";

const ADMINTAGS_VIEW_LOAD = "ADMINTAGS_VIEW_LOAD";
const ADMINTAGS_VIEW_SUCCESS = "ADMINTAGS_VIEW_SUCCESS";
const ADMINTAGS_VIEW_FAILED = "ADMINTAGS_VIEW_FAILED";

const ADMINTAGS_RESET = "ADMINTAGS_RESET";
const ADMINTAGS_RESET_FORM = "ADMINTAGS_RESET_FORM";
const SET_VIEW_DATA = "SET_VIEW_DATA";

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit: process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: "",
  orderMode: "ASC",
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADMINTAGS_RESET:
      return {
        ...initialState
      };
    case ADMINTAGS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case ADMINTAGS_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case ADMINTAGS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case ADMINTAGS_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case ADMINTAGS_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case ADMINTAGS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case ADMINTAGS_FORM_FAILED:
    case ADMINTAGS_EDIT_FAILED:
    case ADMINTAGS_DELETE_FAILED:
    case ADMINTAGS_LIST_FAILED:
    case ADMINTAGS_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case ADMINTAGS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode,
        headerLoaded: false,
        loading: false
      };
    case SET_VIEW_DATA:
    case ADMINTAGS_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        failed: false,
        viewData: action.viewData,
        viewLoading: false
      };
    case ADMINTAGS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case ADMINTAGS_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case ADMINTAGS_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        viewData: get(action, "data.data.data", null),
        id: action.id,
        viewLoading: false
      };
    case ADMINTAGS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
};

export const setViewData = (payload, cashregister_stickern) => dispatch => {
  const viewData = {
    ...payload,
    cashregister_stickern,
    user_name: payload.user_real_name,
    user_number: payload.user_card_number,
    owner_name: payload.client_name
  };

  return dispatch({
    type: SET_VIEW_DATA,
    viewData
  });
};

export const reset = () => dispatch => {
  dispatch({
    type: ADMINTAGS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: ADMINTAGS_RESET_FORM
  });
};

export const updateadmiTags = (model, id, data) => dispatch => {
  dispatch({
    type: ADMINTAGS_EDIT_LOAD
  });

  if (data.operating_address_type !== "other") {
    data.form_values.operating_address = data.operating_address_type;
  }

  let obj = {};
  obj[model] = _.pick(data, [
    "cashregister_apn",
    "cashregister_stickern",
    "user_name",
    "user_number",
    "owner_name",
    "form_values"
  ]);

  return axios
    .put("/v1/shop-admin-tags/" + id, obj, data =>
      dispatch({
        type: ADMINTAGS_EDIT_SUCCESS,
        data: data
      })
    )
    .catch(error => {
      dispatch({
        type: ADMINTAGS_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
    });
};

export const checkKey = (number, apn) => dispatch => {
  dispatch({
    type: ADMINTAGS_VIEW_LOAD
  });

  return axios
    .get("/v1/shop-admin-tags/check-sticker", { params: { number, apn } })
    .then(response => {
      if (response.data.success) {
        dispatch({
          type: ADMINTAGS_VIEW_SUCCESS,
          viewData: null
        });
        return true;
      } else {
        dispatch({
          type: ADMINTAGS_VIEW_FAILED,
          formErrors: { param: ["Hibás Matrica szám"] }
        });
      }
    })
    .catch(error => {
      dispatch({
        type: ADMINTAGS_VIEW_FAILED,
        message: get(error, "response.data.message", null)
      });
    });
};

const getViewData = response => {
  //TODO: Jó lenne, ha szerveren nem stringként jönne;
  let data = get(response, "data.data");
  if (data && data.form_values && typeof data.form_values === "string") {
    data.form_values = JSON.parse(data.form_values);
  }
  return data;
};

export const viewadmiTags = id => dispatch => {
  dispatch({
    type: ADMINTAGS_VIEW_LOAD
  });
  return axios
    .get("/v1/shop-admin-tags/" + id)
    .then(response =>
      dispatch({
        type: ADMINTAGS_VIEW_SUCCESS,
        viewData: getViewData(response),
        commentThread: get(response, "data.commentThread", false)
      })
    )
    .catch(error => {
      dispatch({
        type: ADMINTAGS_VIEW_FAILED,
        message: get(error, "response.data.message", null)
      });
    });
};

export const create = tag => dispatch => {
  dispatch({
    type: ADMINTAGS_EDIT_LOAD
  });

  let obj = {
    ShopTag: {
      name: tag
    }
  };

  return axios
    .post("/v1/shop-admin-tags", obj)
    .then(response =>
      dispatch({
        type: ADMINTAGS_EDIT_SUCCESS,
        id: get(response, "data.data.id", null),
        data: response
      })
    )
    .catch(error => {
      dispatch({
        type: ADMINTAGS_EDIT_FAILED,
        message: get(error, "response.data.message", null),
        formErrors: get(error, "response.data.form_errors", {})
      });
    });
};

export const admintagsDelete = id => dispatch => {
  dispatch({
    type: ADMINTAGS_DELETE_LOAD
  });
  return axios
    .delete("/v1/shop-admin-tags/" + id)
    .then(() =>
      dispatch({
        type: ADMINTAGS_DELETE_SUCCESS,
        id
      })
    )
    .catch(error =>
      dispatch({
        type: ADMINTAGS_DELETE_FAILED,
        message: get(error, "response.data.message", null)
      })
    );
};

export const setLoading = loading => dispatch => {
  dispatch({
    type: ADMINTAGS_SET_LOADING,
    loading
  });
};
export const admintagsList = (
  page,
  keyword,
  sort,
  filters,
  perPage
) => dispatch => {
  dispatch({
    type: ADMINTAGS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    "per-page": perPage
  };

  params[filters.model] = filters.filters;

  return axios
    .get(
      "/v1/shop-admin-tags",
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    )
    .then(response => {
      let sort = get(response, "data.sort", null),
        mode = "ASC";
      if (sort && sort.indexOf("-") !== -1) {
        mode = "DESC";
        sort = sort.substr(1);
      }
      dispatch({
        type: ADMINTAGS_LIST_SUCCESS,
        data: get(response, "data.data", null),
        page: get(response, "data.page", 0),
        limit: get(response, "data.per-page", 0),
        total: get(response, "data.total", 0),
        order: sort,
        orderMode: mode
      });

      return response.data;
    })
    .catch(error =>
      dispatch({
        type: ADMINTAGS_LIST_FAILED,
        message: get(error, "response.data.message", null)
      })
    );
};

export const downloadPDF = id => dispatch => {
  return dispatch(
    fileActions.download(
      `/v1/shop-admin-tags/pdf/${id}`,
      `annual_review_${moment().format("YYYY-MM-DD")}.pdf`
    )
  );
};
